/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-21 09:10:19
 * @LastEditTime: 2020-08-14 10:48:11
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/router/index.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home/Home";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  /**
   * 实现keepAlive的配置
   * @param {*} to
   * @param {*} from
   * @param {*} savedPosition
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  //mode:'history',
  routes: [
    {
      path: "",
      component: Home,
      redirect: "/feeAudit",
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: []
    },
    {
      path: "/login",
      name: "Login",
      // component: () =>
      //   import(/* webpackChunkName: "login" */ "@/views/login/Login"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/unionWelfareManagement",
      component: Home,
      children: [
        {
          path: "/",
          name: "Welfare management",
          component: () =>
            import(/* webpackChunkName: "Index" */ "@/views/Welfare/Welfare"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/unionWelfareStaff",
      component: Home,
      children: [
        {
          path: "/",
          name: "WelfareStaff management",
          component: () =>
            import(
              /* webpackChunkName: "Index" */ "@/views/Welfare/WelfareStaff"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/order",
      component: Home,
      children: [
        {
          path: "/",
          name: "order management",
          component: () =>
            import(/* webpackChunkName: "Index" */ "@/views/Order/Order"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/",
      name: "FeeAudit management",
      redirect: "/",
      component: Home,
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "feeAudit",
          name: "FeeAudit",
          component: () =>
            import(
              /* webpackChunkName: "FeeAudit" */ "@/views/FeeAudit/FeeAudit"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "newlyMarried",
          name: "NewlyMarried",
          component: () =>
            import(
              /* webpackChunkName: "NewlyMarried" */ "@/views/NewlyMarried/NewlyMarried"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/",
      name: "Union management",
      redirect: "/",
      component: Home,
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "unionApproved",
          name: "UnionApproved",
          component: () =>
            import(
              /* webpackChunkName: "UnionApproved" */ "@/views/UnionApproved/UnionApproved"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "unionManagement",
          name: "UnionManagement",
          component: () =>
            import(
              /* webpackChunkName: "UnionManagement" */ "@/views/UnionManagement/UnionManagement"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/feeAudit",
      component: Home,
      children: [
        {
          path: "/",
          name: "FeeAudit management",
          component: () =>
            import(/* webpackChunkName: "Index" */ "@/views/FeeAudit/FeeAudit"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/index",
      component: Home,
      children: [
        {
          path: "/",
          name: "index",
          component: () =>
            import(/* webpackChunkName: "Index" */ "@/views/Index/Index"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/",
      name: "User Mgt",
      redirect: "/",
      component: Home,
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "account",
          name: "account",
          component: () =>
            import(
              /* webpackChunkName: "Account" */ "@/views/User/Account/Account"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "user",
          name: "user",
          component: () =>
            import(/* webpackChunkName: "User" */ "@/views/User/User/User"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "group",
          name: "group",
          component: () =>
            import(/* webpackChunkName: "Group" */ "@/views/User/Group/Group"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "domain",
          name: "domain",
          component: () =>
            import(/* webpackChunkName: "Area" */ "@/views/User/Area/Area"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "unit",
          name: "unit",
          component: () =>
            import(/* webpackChunkName: "unit" */ "@/views/User/Unit/Unit"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "synchronizer",
          name: "ID Synchronizer",
          component: () =>
            import(
              /* webpackChunkName: "Synchronizer" */ "@/views/User/Synchronizer/Synchronizer"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/",
      name: "Permission",
      redirect: "/",
      component: Home,
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "role",
          name: "role",
          component: () =>
            import(
              /* webpackChunkName: "Role" */ "@/views/Permission/Role/Role"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "menu",
          name: "menu",
          component: () =>
            import(
              /* webpackChunkName: "Menu" */ "@/views/Permission/Menu/Menu"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "action",
          name: "Action",
          component: () =>
            import(
              /* webpackChunkName: "element" */ "@/views/Permission/Element/Element"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "endpoint",
          name: "Endpoint",
          component: () =>
            import(
              /* webpackChunkName: "Endpoint" */ "@/views/Permission/Endpoint/Endpoint"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "permission",
          name: "permission",
          component: () =>
            import(
              /* webpackChunkName: "Permission" */ "@/views/Permission/Permission/Permission"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/",
      name: "System",
      redirect: "/",
      component: Home,
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "template",
          name: "template",
          component: () =>
            import(
              /* webpackChunkName: "Template" */ "@/views/System/Template/Template"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "i18n",
          name: "i18n",
          component: () =>
            import(
              /* webpackChunkName: "Language" */ "@/views/System/Language/Language"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "configuration",
          name: "configuration",
          component: () =>
            import(
              /* webpackChunkName: "SystemConf" */ "@/views/System/SystemConf/SystemConf"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "audit",
          name: "audit",
          component: () =>
            import(
              /* webpackChunkName: "AuditLog" */ "@/views/System/AuditLog/AuditLog"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        },
        {
          path: "information",
          name: "SystemInfo",
          component: () =>
            import(
              /* webpackChunkName: "SystemInfo" */ "@/views/System/SystemInfo/SystemInfo"
            ),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js